module.exports = __webpack_public_path__ + "img/up-and-down-arrow.c6517037.svg";